/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strength_Level_NoviceInputs */

const en_strength_level_novice = /** @type {(inputs: Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novice`)
};

const pl_strength_level_novice = /** @type {(inputs: Strength_Level_NoviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowicjusz`)
};

/**
* | output |
* | --- |
* | "Novice" |
*
* @param {Strength_Level_NoviceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const strength_level_novice = /** @type {((inputs?: Strength_Level_NoviceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strength_Level_NoviceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_strength_level_novice(inputs)
	return en_strength_level_novice(inputs)
});